import { render, staticRenderFns } from "./Footernew.vue?vue&type=template&id=12239106&scoped=true&"
import script from "./Footernew.vue?vue&type=script&lang=js&"
export * from "./Footernew.vue?vue&type=script&lang=js&"
import style0 from "./Footernew.vue?vue&type=style&index=0&id=12239106&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12239106",
  null
  
)

export default component.exports